<template>
  <div>
    <md-card>
      <md-card-header>
        <div class="md-title">Welcome</div>
      </md-card-header>
      <md-card-content>Hi {{UserEmail}}! Welcome to DAMAC Admin Dashboard</md-card-content>
    </md-card>
  </div>
</template>


<script>
export default {
  beforeMount() {
    this.$store.dispatch("setIsProgressVisible", false);
    this.$store.dispatch("setCurrentRoute", "/dashboard");
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {},
  computed: {
    UserEmail() {
      return this.$mcdStore.get("userEmail");
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/dashboard.vue